<template>
  <v-card elevation="0">
    <s-toolbar v-if="visibleTitle" label="Datos Asegurados" />
    <v-card-text>
      <v-row>
        <!-- Contenedor para SCTR Pensión -->
        <v-col class="s-col-form" sm="6" md="6">
          <v-card dense>
            <v-card-title class="text-h7" style="font-weight: bold">
              <v-row>
                <v-col>
                  <h5>
                    {{ editedPensionIndex != -1 ? "EDITAR" : "NUEVOS" }} DATOS
                    DEL SISTEMA PENSIONARIO
                  </h5>
                </v-col>
                <div style="text-align: end" v-if="editedPensionIndex != -1">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    @click="cancelItemDetail(0)"
                    color="error"
                  >
                    <v-icon dark>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div style="text-align: end">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    @click="addItemDetail(0)"
                    color="success"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </div>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="s-col-form" cols="6" sm="6" lg="6">
                  <s-select-definition
                    :def="1499"
                    label="Régimen pensionario"
                    v-model="item.TypePensionRegimen"
                    :add="$fun.isAdmin()"
                    ref="TypePensionRegimenRef"
                  />
                </v-col>
                <v-col class="s-col-form" cols="6" sm="6" lg="6">
                  <s-text
                    label="Código de Afiliado (C.U.S.P.P)"
                    v-model="item.CUSPP"
                    :maxlength="12"
                    :showCounter="true"
                    :rules="[
                      //value => !!value || 'aaa',
                      (value) =>
                        (value && value.length >= 12) ||
                        'El Código de Afiliado debe de tener 12 digitos',
                    ]"
                    :uppercase="true"
                    @keydownSpace="clear()"
                  >
                  </s-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" lg="12">
                  <v-file-input
                    accept=".pdf"
                    label="Anexo"
                    v-model="Attach"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12" md="12" lg="12">
                  <v-data-table
                    :headers="pensionHeaders"
                    class="elevation-1"
                    :items="pensionDetail"
                    :sort-by="['SecStatus', 'index']"
                    :sort-desc="[true]"
                  >
                    <template v-slot:[`item.PsnBeginDate`]="{ item }">
                      {{ item.PsnBeginDate ? $moment(item.PsnBeginDate).format($const.FormatDateView) : "" }}
                    </template>
                    <template v-slot:[`item.PsnEndDate`]="{ item }">
                      {{ item.PsnEndDate ? $moment(item.PsnEndDate).format($const.FormatDateView) : "" }}
                    </template>
                    <template v-slot:[`item.selected`]="{ item }">
                      <v-chip
                        small
                        style="cursor: pointer"
                        @click="selectPension(item)"
                        :color="item.selected ? 'success' : 'grey lighten-2'"
                        :text-color="item.selected ? 'white' : 'black'"
                      >
                        <v-icon small left v-if="item.selected">mdi-check-circle</v-icon>
                        {{ item.selected ? 'ANEXADO' : 'ANEXAR' }}
                      </v-chip>
                    </template>
                    <template v-slot:[`item.SecStatus`]="{ item }">
                      <v-chip small :color="item.SecStatus ? 'success' : ''" :text-color="item.SecStatus ? 'white' : ''">
                        {{ item.SecStatus ? "Activo" : "Inactivo" }}
                      </v-chip>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item, 0)">mdi-pencil</v-icon>
                      <v-icon small @click="deleteItem(item, 0)">mdi-delete</v-icon>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Contenedor para SCTR Salud -->
        <v-col class="s-col-form" sm="6" md="6">
          <v-card dense>
            <v-card-title class="text-h7" style="font-weight: bold">
              <v-row>
                <v-col>
                  <h5>
                    {{ editedHealthIndex != -1 ? "EDITAR" : "NUEVOS" }} DATOS
                    DEL SISTEMA SALUD
                  </h5>
                </v-col>
                <div style="text-align: end" v-if="editedHealthIndex != -1">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    @click="cancelItemDetail(1)"
                    color="error"
                  >
                    <v-icon dark>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div style="text-align: end">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    @click="addItemDetail(1)"
                    color="success"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </div>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col sm="12" md="12" :lg="itemHealth.TypeHealthRegimen == 2 ? 6 : 12">
                  <s-select-definition
                    :def="1509"
                    label="Seguro"
                    v-model="itemHealth.TypeHealthRegimen"
                    :add="$fun.isAdmin()"
                    ref="TypeHealthRegimenRef"
                  />
                </v-col>
                <v-col sm="12" md="12" lg="6" v-if="itemHealth.TypeHealthRegimen == 2">
                  <s-select-definition
                    :def="1529"
                    label="Compañía"
                    v-model="itemHealth.TypeCompany"
                    :add="$fun.isAdmin()"
                    ref="TypeCompanyRef"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12" md="12" lg="12">
                  <v-data-table
                    :headers="healthHeaders"
                    class="elevation-1"
                    :items="healthDetail"
                    :sort-by="['SecStatus', 'index']"
                    :sort-desc="[true]"
                  >
                    <template v-slot:[`item.HthStartDate`]="{ item }">
                      {{ item.HthStartDate ? $moment(item.HthStartDate).format($const.FormatDateView) : "" }}
                    </template>
                    <template v-slot:[`item.HthEndDate`]="{ item }">
                      {{ item.HthEndDate ? $moment(item.HthEndDate).format($const.FormatDateView) : "" }}
                    </template>
                    <template v-slot:[`item.selected`]="{ item }">
                      <v-chip
                        small
                        style="cursor: pointer"
                        @click="selectHealth(item)"
                        :color="item.selected ? 'success' : 'grey lighten-2'"
                        :text-color="item.selected ? 'white' : 'black'"
                      >
                        <v-icon small left v-if="item.selected">mdi-check-circle</v-icon>
                        {{ item.selected ? 'ANEXADO' : 'ANEXAR' }}
                      </v-chip>
                    </template>
                    <template v-slot:[`item.SecStatus`]="{ item }">
                      <v-chip small :color="item.SecStatus ? 'success' : ''" :text-color="item.SecStatus ? 'white' : ''">
                        {{ item.SecStatus ? "Activo" : "Inactivo" }}
                      </v-chip>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small class="mr-2" @click="editItem(item, 1)">mdi-pencil</v-icon>
                      <v-icon small @click="deleteItem(item, 1)">mdi-delete</v-icon>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import _sGeneral from "@/services/HelperService.js";

export default {
  name: "sDataInsured",
  components: {},
  props: {
    visibleTitle: {
      type: Boolean,
      default: true,
    },
    full: {
      type: Boolean,
      default: false,
    },
    typeperson: {
      type: Number,
      default: 1,
    },
    addTypeSex: {
      type: Boolean,
      default: false,
    },
    addBirthDate: {
      type: Boolean,
      default: false,
    },
    addDriver: {
      type: Boolean,
      default: false,
    },
    datawork: { type: Object },
  },
  data() {
    return {
      dataWor: {},
      editing: false,
      item: {
        TypePensionRegimen: 5,
        CUSPP: "",
        PsnBeginDate: this.$fun.getDate(""),
        TypeHealthRegimen: 1,
        HthCompany: 1,
        PsnEndDate: null,
        PsnAttach: null,
      },
      Attach: null,
      itemHealth: {
        HthScireID: 0,
        TypeHealthRegimen: 1,
        TypeCompany: 1,
        HthStartDate: null,
        HthEndDate: null,
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      },
      selectedCenterCost: 0,
      selectedBusinessLine: null,
      menu3: false,
      config: {},
      dialog: false,
      editedIndex: -1,
      editedPensionIndex: -1,
      editedHealthIndex: -1,
      title: -1,
      pensionHeaders: [
        { text: "C.U.S.P.P.", value: "CUSPP", sortable: false, width: 50 },
        { text: "Inicio Aportación", value: "PsnBeginDate", sortable: false, width: 50 },
        { text: "Fin Aportación", value: "PsnEndDate", sortable: false, width: 50 },
        {
          text: "Régimen Pensionario",
          value: "TypePensionRegimenName",
          sortable: false,
          width: 50,
        },
        { text: "Anexo", value: "PsnAttach", sortable: false, width: 50 },
        { text: "Estado", value: "SecStatus", sortable: false, width: 20 },
        { text: "Acciones", value: "actions", sortable: false, width: 20 },
      ],
      pensionDetail: [],
      healthHeaders: [
        {
          text: "Seguro",
          value: "TypeHealthRegimenName",
          sortable: false,
          width: 50,
        },
        {
          text: "Compañía",
          value: "HthCompanyName",
          sortable: false,
          width: 20,
        },
        {
          text: "Fecha de Inicio",
          value: "HthStartDate",
          sortable: false,
          width: 20,
        },
        {
          text: "Fecha de Fin",
          value: "HthEndDate",
          sortable: false,
          width: 20,
        },
        { text: "Estado", value: "SecStatus", sortable: false, width: 30 },
        { text: "Acciones", value: "actions", sortable: false, width: 30 },
      ],
      healthDetail: [],
    };
  },
  inject: ["contractDates"], // Recibe las fechas
  methods: {
    getDefinitionDescription(refName, value, fallback = "") {
      const items = this.$refs?.[refName]?.items || [];
      const found = items.find((x) => x.DedValue === value);
      return found?.DedDescription || fallback;
    },
    uploadFile() {
      var formData = new FormData();
      let i = 0;

      formData.append(i.toString(), this.Attach);
      i++;

      _sGeneral.uploadfile("123", this.$fun.getUserID(), formData, 3);
      this.$fun.alert("Guardado Correctamente", "success");
      this.$emit("onClose");
    },

    openFile(url) {
      // console.log("Nombre de url", url);
      _sGeneral.download(url.name, this.$fun.getUserID()).then((r) => {
        // console.log("rtpa",r);
        this.$fun.download(r.data, url.name);
        // if(r.status === 200){

        // 	this.$fun.downloadHttp(r);
        // }
      });
    },

    saveFile() {
      // console.log("Nombre del Archivo: " , this.Attach);
      // console.log("Item:" , this.selected);
      this.uploadFile();
    },
    initialize() {
      this.item = { ...this.item };
      this.itemHealth = { ...this.itemHealth };
    },
    clear(event) {
      console.log("evento", event);
    },

    close() {
      this.$refs.document.focus();
      this.$emit("toclose", 2);
      this.clear();
    },
    save() {},
    getData() {
      if (!this.validateData()) return false;

      const pension = this.pensionDetail.find((x) => x.SecStatus === 1);
      const health = this.healthDetail.find((x) => x.SecStatus === 1);

      return {
        HmnPension: pension
          ? {
              CUSPP: (pension.CUSPP || "").toUpperCase(),
              PsnBeginDate: pension.PsnBeginDate,
              PsnEndDate: pension.PsnEndDate,
              PsnAttach: pension.PsnAttach || null,
              TypePensionRegimen: pension.TypePensionRegimen,
              UsrCreateID: this.$fun.getUserID(),
            }
          : null,
        HmnHealth: health
          ? {
              HthScireID: 0,
              TypeHealthRegimen: health.TypeHealthRegimen,
              TypeCompany: health.TypeHealthRegimen == 2 ? health.TypeCompany : null,
              HthStartDate: health.HthStartDate,
              HthEndDate: health.HthEndDate,
              SecStatus: 1,
              UsrCreateID: this.$fun.getUserID(),
            }
          : null,
      };
    },

    addItemDetail(detail) {
      if (!this.validateItemDetail(detail)) return;

      if (detail === 0) {
        const pension = {
          CUSPP: (this.item.CUSPP || "").replace(/\s+/g, "").toUpperCase(),
          PsnBeginDate: this.item.PsnBeginDate,
          PsnEndDate: this.item.PsnEndDate,
          TypePensionRegimen: this.item.TypePensionRegimen,
          TypePensionRegimenName: this.getDefinitionDescription(
            "TypePensionRegimenRef",
            this.item.TypePensionRegimen
          ),
          PsnAttach: this.Attach?.name || null,
          SecStatus: 1,
          UsrCreateID: this.$fun.getUserID(),
        };

        this.pensionDetail.forEach((x) => {
          x.SecStatus = 0;
        });

        if (this.editedPensionIndex > -1) {
          Object.assign(this.pensionDetail[this.editedPensionIndex], pension);
        } else {
          this.pensionDetail.push(pension);
        }

        this.pensionDetail = this.pensionDetail.map((item, index) => ({
          ...item,
          index,
        }));

        this.editedPensionIndex = -1;
      }

      if (detail === 1) {
        const health = {
          HthScireID: 0,
          TypeHealthRegimen: this.itemHealth.TypeHealthRegimen,
          TypeHealthRegimenName: this.getDefinitionDescription(
            "TypeHealthRegimenRef",
            this.itemHealth.TypeHealthRegimen
          ),
          TypeCompany:
            this.itemHealth.TypeHealthRegimen == 2 ? this.itemHealth.TypeCompany : null,
          TypeCompanyName:
            this.itemHealth.TypeHealthRegimen == 2
              ? this.getDefinitionDescription("TypeCompanyRef", this.itemHealth.TypeCompany)
              : null,
          HthStartDate: this.itemHealth.HthStartDate,
          HthEndDate: this.itemHealth.HthEndDate,
          SecStatus: 1,
          UsrCreateID: this.$fun.getUserID(),
        };

        this.healthDetail.forEach((x) => {
          x.SecStatus = 0;
        });

        if (this.editedHealthIndex > -1) {
          Object.assign(this.healthDetail[this.editedHealthIndex], health);
        } else {
          this.healthDetail.push(health);
        }

        this.healthDetail = this.healthDetail.map((item, index) => ({
          ...item,
          index,
        }));

        this.editedHealthIndex = -1;
      }

      this.clearDetail(detail);
    },

    editItem(item, detail) {
      if (detail === 0) {
        this.editedPensionIndex = this.pensionDetail.indexOf(item);
        this.item = {
          ...this.item,
          CUSPP: item.CUSPP || "",
          PsnBeginDate: item.PsnBeginDate || null,
          PsnEndDate: item.PsnEndDate || null,
          TypePensionRegimen: item.TypePensionRegimen || 5,
        };
        this.Attach = item.PsnAttach ? { name: item.PsnAttach } : null;
      }

      if (detail === 1) {
        this.editedHealthIndex = this.healthDetail.indexOf(item);
        this.itemHealth = {
          ...this.itemHealth,
          TypeHealthRegimen: item.TypeHealthRegimen || 1,
          TypeCompany: item.TypeCompany || 1,
          HthStartDate: item.HthStartDate || null,
          HthEndDate: item.HthEndDate || null,
        };
      }
    },

    deleteItem(item, detail) {
      if (detail === 0) {
        item.SecStatus = item.SecStatus === 1 ? 0 : 1;
        if (item.SecStatus === 0 && item.selected) {
          item.selected = false;
        }
      }
      if (detail === 1) {
        item.SecStatus = item.SecStatus === 1 ? 0 : 1;
        if (item.SecStatus === 0 && item.selected) {
          item.selected = false;
        }
      }
      this.clearDetail(detail);
    },

    selectPension(item) {
      if (!item) return;
      item.SecStatus = 1;
      this.pensionDetail.forEach((x) => {
        x.selected = x === item;
      });
      this.$emit("update:selectedPsnID", item.PsnID || item.index || 0);
    },

    selectHealth(item) {
      if (!item) return;
      item.SecStatus = 1;
      this.healthDetail.forEach((x) => {
        x.selected = x === item;
      });
      this.$emit("update:selectedHthID", item.HthID || item.index || 0);
    },

    cancelItemDetail(detail) {
      this.clearDetail(detail);
    },

    clearDetail(detail) {
      if (detail === 0) {
        this.editedPensionIndex = -1;
        this.item = {
          ...this.item,
          CUSPP: "",
          TypePensionRegimen: 5,
          PsnBeginDate: this.contractDates.AgtAdmissionDate || this.item.PsnBeginDate,
          PsnEndDate: this.contractDates.AgtEndDate || null,
        };
        this.Attach = null;
      }
      if (detail === 1) {
        this.editedHealthIndex = -1;
        this.itemHealth = {
          ...this.itemHealth,
          TypeHealthRegimen: 1,
          TypeCompany: 1,
          HthStartDate: this.contractDates.AgtAdmissionDate || this.itemHealth.HthStartDate,
          HthEndDate: this.contractDates.AgtEndDate || null,
        };
      }
    },

    validateItemDetail(detail) {
      let valid = true;
      let message = "";

      if (detail === 0) {
        if (!this.item.CUSPP) {
          message = "El Código de Afiliado C.U.S.P.P es obligatorio";
        } else if ((this.item.CUSPP || "").replace(/\s+/g, "").length < 12) {
          message = "El Código de Afiliado C.U.S.P.P es de 12 dígitos";
        } else if (!this.$fun.isValidDate(this.item.PsnBeginDate)) {
          message = "Fecha no Valida del Campo Inicio de Aportación";
        } else if (this.item.PsnEndDate && !this.$fun.isValidDate(this.item.PsnEndDate)) {
          message = "Fecha no Valida del Campo Fin de Aportación";
        }
      }

      if (detail === 1) {
        if (!this.$fun.isValidDate(this.itemHealth.HthStartDate)) {
          message = "Fecha no Valida del Campo Fecha de Inicio";
        } else if (
          this.itemHealth.HthEndDate &&
          !this.$fun.isValidDate(this.itemHealth.HthEndDate)
        ) {
          message = "Fecha no Valida del Campo Fecha de Fin";
        }
      }

      if (message) {
        this.$fun.alert(message, "warning");
        valid = false;
      }

      return valid;
    },

    validateData() {
      let valid = true;
      if (!this.pensionDetail.some((x) => x.SecStatus === 1)) {
        this.$fun.alert("Debe agregar un registro de Sistema Pensionario", "warning");
        valid = false;
      }

      if (!this.healthDetail.some((x) => x.SecStatus === 1)) {
        this.$fun.alert("Debe agregar un registro de Sistema Salud", "warning");
        valid = false;
      }

      return valid;
    },
    updateDate() {
      if (this.contractDates.AgtEndDate) {
        this.item.PsnEndDate = this.contractDates.AgtEndDate;
        this.itemHealth.HthEndDate = this.contractDates.AgtEndDate;
      }

      if (this.contractDates.AgtAdmissionDate) {
        this.item.PsnBeginDate = this.contractDates.AgtAdmissionDate;
        this.itemHealth.HthStartDate = this.contractDates.AgtAdmissionDate;
      }
    },
  },
  watch: {
    "contractDates.AgtAdmissionDate"() {
      this.updateDate();
    },
    "contractDates.AgtEndDate"() {
      this.updateDate();
    },
  },
  created() {
    this.initialize();
    this.updateDate();
  },
};
</script>
